module.exports = __webpack_public_path__ + "img/22.f19c01c0.jpg";